import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { noop } from 'lodash'
import { DisclaimersButton, If } from 'src/Components'
import styles from './AdditionalInfo.module.scss'

const defaultProps = {
  cardWidth: false,
  cardBottom: false,
  showDisclaimers: true,
  visible: false,
}

const propTypes = {
  cardWidth: PropTypes.bool,
  cardBottom: PropTypes.bool,
  showDisclaimers: PropTypes.bool,
  visible: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  targetRef: PropTypes.shape({
    current: PropTypes.oneOfType([PropTypes.element, PropTypes.object]),
  }),
  onMouseOver: PropTypes.func,
}

const AdditionalInfo = ({
  visible,
  children,
  className,
  cardBottom,
  showDisclaimers,
  onMouseOver = noop,
}) => {
  const outerRef = useRef(null)

  const tipClass = classnames(styles.content, {
    [styles.open]: visible,
    [styles.cardBottom]: cardBottom,
  })

  return (
    <div ref={outerRef} className={className} onMouseOver={onMouseOver}>
      <div className={tipClass}>
        {children}
        <If condition={showDisclaimers}>
          <DisclaimersButton className={styles.button} />
        </If>
      </div>
    </div>
  )
}

AdditionalInfo.defaultProps = defaultProps
AdditionalInfo.propTypes = propTypes

export default AdditionalInfo
